import React from 'react'
import styled, { css } from 'styled-components'

export const CardContainer = styled.div`
  ${({ isShowAddButt }) => css`
    min-height: 300px;
  `}
  aspect-ratio: 0.72 / 1;
  min-height: 280px;
  max-width: 280px;
  background: ${({ bgColor }) => bgColor || '#0a0a0a'};
  color: ${({ textColor }) => textColor || '#FFF'};
  border: 1.5px solid ${({ borderColor }) => borderColor || '#FF007F'};
  box-shadow: 0 0 8px ${({ borderColor }) => borderColor ? `${borderColor}66` : '#FF007F66'};
  padding: 12px;

  @media (max-width: 768px) {
    min-height: 220px;
    padding: 6px;
    max-width: 100%;
    margin: 8px 6px;
  }
  margin: 10px;
  border-radius: 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  position: relative;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 0 20px ${({ borderColor }) => borderColor ? `${borderColor}99` : '#FF007F99'};
  }
  ${({ useCustomFunctionality }) => useCustomFunctionality && css`
      justify-content: center;
    `}

  > div.product-content {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    flex: 1;
    min-height: 0;
    ${({ useCustomFunctionality }) => useCustomFunctionality && css`
      justify-content: center;
      align-items: center;
    `}
  }

  .price-add-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 15px;
    padding: 0 4px;
  }

  .add-btn {
    background: transparent !important;
    border: 2px solid ${({ borderColor }) => borderColor || '#FF007F'} !important;
    color: ${({ textColor }) => textColor || '#FFF'} !important;
    border-radius: 29px !important;
    padding: 4px 16px !important;
    font-size: 14px !important;
    height: 34px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-transform: capitalize !important;
    font-weight: 400 !important;

    @media (min-width: 768px) {
      padding: 6px 24px !important;
      font-size: 16px !important;
      height: 40px !important;
    }

    width: auto !important;
    margin: 0 8px 0 0 !important;
    box-shadow: 0 0 10px ${({ borderColor }) => borderColor || '#FF007F'};
    transition: all 0.2s;
    letter-spacing: 0.5px;

    &:hover {
      background: ${({ borderColor }) => borderColor || '#FF007F'} !important;
      color: #000 !important;
      box-shadow: 0 0 20px ${({ borderColor }) => borderColor || '#FF007F'} !important;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .qty-controls {
    display: flex;
    align-items: center;
    border: 2px solid ${({ borderColor }) => '#FF007F'};
    border-radius: 29px;
    padding: 4px 8px;
    background-color: #fff;
    height: 34px;
    box-sizing: border-box;
    margin-right: 8px;

    @media (min-width: 768px) {
      height: 40px;
      padding: 4px 12px;
    }

    .control {
      cursor: pointer;
      font-size: 18px;
      font-weight: bold;
      color: ${({ textColor }) => textColor || '#FFF'};
      user-select: none;
      padding: 0 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: color 0.2s;

      &:hover {
        color: ${({ borderColor }) => borderColor || '#FF007F'};
      }
    }

    .qty {
      color: ${({ textColor }) => textColor || '#FFF'};
      font-weight: 700;
      font-size: 12px;
      margin: 0 5px;
      @media (min-width: 768px) {
        font-size: 16px;
        margin: 0 12px;
      }
    }
  }

  button {
    width: 100%;
    margin-top: 10px;
    padding: 2px;
  }
  ${({ productsRows }) => productsRows
    ? css`
    width: ${() => productsRows === 3 ? 'calc(33% - 20px)' : 'calc(50% - 20px)'};
    margin: 10px 0;

  `
    : css`
    width: calc(50% - 20px);
    margin: 10px;

    @media (max-width: 768px) {
      margin: 8px 6px;
      width: calc(50% - 12px);
      min-height: 240px;
      padding: 10px 8px;
    }

  ${({ isCartOnProductsList }) => isCartOnProductsList
        ? css`
    @media (min-width: 993px) {
      width: calc(50% - 20px);
      margin: 10px 20px 10px 0px;
      ${props => props.theme?.rtl && css`
        margin: 10px 0px 10px 20px;
      `}
    }
  `
        : css`
    @media (min-width: 681px) {
      width: calc(49% - 20px);
    }

    @media (min-width: 993px) {
      width: calc(25% - 20px);
      margin: 10px 20px 10px 0px;
      ${props => props.theme?.rtl && css`
        margin: 10px 0px 10px 20px;
      `}
    }

    @media (min-width: 1200px) {
      width: calc(20% - 20px);
    }

    @media (min-width: 1440px) {
      width: calc(16.66% - 20px);
    }
  `}

  `}
`

export const SoldOut = styled.span`
  font-weight: bold;
  position: absolute;
  background: #495057 0% 0% no-repeat padding-box;
  padding: 5px 10px;
  top: 7px;
  border-radius: 2px 0px 0px 2px;
  right: 0px;
  color: white;
  font-size: 12px;
  ${props => props.theme?.rtl && css`
    left: 0px;
    right: initial;
  `}
  &:first-letter {
    text-transform: uppercase;
  }

  ${({ isBottom }) => isBottom && css`
    bottom: 7px;
    top: initial;
  `}
`

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  color: ${({ textColor }) => textColor || '#FFF'};
  > * {
    margin: 5px 0;
  }
  p.short-desc {
    color: ${({ textColor }) => textColor === '#000' ? '#222' : '#DDD'};
    font-size: 14px;
    margin: 6px 0 15px 0;
    text-align: left;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    white-space: pre-wrap;
    font-weight: 300;
  }

  span {
    color: ${({ textColor }) => textColor || '#FFF'};
    font-size: 14px;
  }

  ${({ oneLine }) => oneLine && css`
    p.short-desc {
      -webkit-line-clamp: 1;
    }
  `}

  @media (max-width: 768px) {
    p.short-desc {
      font-size: 11px;
      margin-bottom: 8px;
    }
    span {
      font-size: 13px;
    }
  }

  @media (min-width: 1024px) {
    p.short-desc {
      font-size: 12px;
    }

    span {
      font-size: 14px;
    }
  }
`

export const WrapLogo = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
  height: 48%;
  max-height: 50%;
  padding: 10px 0;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    padding: 5px 0;
    margin-bottom: 8px;
  }
  ${props => props.theme?.rtl && css`
  `}
`

export const WrapTags = styled.div`
  display: flex;
  margin-left: 10px;
  margin-right: 10px;
  overflow-x: auto;

  ${({ isBgimage }) => isBgimage && css`
    width: 50px;
  `}
  ${props => props.theme?.rtl && css`
    margin-right: 5px;
    margin-left: 0px;
  `}

  div {
    display: flex;
    margin: auto;
  }
  ::-webkit-scrollbar {
    display: none;
  }

  img {
    width: 30px;
    height: 30px;
    margin-right: 5px;
  }
`

const CardLogoStyled = styled.div`
  box-sizing: border-box;
  position: relative;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 100%;
  height: 100%;
`
export const CardLogo = (props) => {
  const style = {}
  if (props.bgimage) {
    style.backgroundImage = `url(${props.bgimage})`
  }
  if (props.soldOut) {
    style.filter = 'brightness(70%)'
  }
  return (
    <CardLogoStyled {...props} style={style}>
      {props.children}
    </CardLogoStyled>
  )
}

export const PriceWrapper = styled.div`
  display: flex;
  align-items: center;

  .current-price {
    font-family: 'Anton', sans-serif;
    font-size: 12px;
    @media (min-width: 768px) {
      font-size: 18px;
    }
    color: ${({ textColor }) => textColor || '#FFF'};
    letter-spacing: 1px;
    white-space: nowrap;
  }
  .off-price {
    font-size: 12px;
    color: ${({ textColor }) => textColor === '#000' ? '#333' : '#DDD'};
    margin-left: 8px;
    ${({ isOffPrice }) => isOffPrice && css`
      min-width: 46px;
    `}
    ${props => props.theme.rtl && css`
      margin-right: 5px;
      margin-left: 0;
    `}

    @media (min-width: 1024px) {
      font-size: 13px;
      ${({ isOffPrice }) => isOffPrice && css`
        min-width: 64px;
      `}
    }
  }
`

export const QuantityContainer = styled.div`
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primaryContrast};
  position: absolute;
  left: 100%;
  bottom: 98%;
  width: 25px;
  height: 25px;
  text-align: center;
  border-radius: 50%;
  transform: translate(-20px, 50%);

  @media (min-width: 768px) {
    transform: translate(-50%, 50%);
  }
`

export const RibbonBox = styled.div`
  position: absolute;
  padding: 2px 8px;
  box-sizing: border-box;
  z-index: 10;
  color: ${props => props.theme.colors.colorTextSignForm};
  font-weight: 400;
  font-size: 10px;
  line-height: 13px;
  top: -4px;
  right: -3px;
  background-color: ${props => props.theme.colors.primary};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  max-width: 70px;
  word-break: break-all;

  ${props => props.theme.rtl && css`
    left: -3px;
    right: initial;
  `}

  ${({ bgColor }) => bgColor && css`
    background-color: ${bgColor};
  `}

  ${({ isRoundRect }) => isRoundRect && css`
    border-radius: 7.6px;
  `}

  ${({ isCapsule }) => isCapsule && css`
    border-radius: 50px;
  `}
`

export const LastOrder = styled.span`
  color: ${props => props.theme.colors.primary};
  font-weight: 400;
  font-size: 10px !important;
  margin: 0px 3px;
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  h1 {
    font-family: 'Bebas Neue', regular;
    font-size: 14px;
    @media (min-width: 768px) {
      font-size: 21px;
    }
    font-weight: 600;
    text-align: left;
    color: inherit;
    margin: 0px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    white-space: pre-wrap;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    line-height: 1.1;
  }

  > span {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    svg {
      color: ${props => props.theme.colors.danger500};
      font-size: 16px;
    }
  }
`
export const SkeletonCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 90px);
  > * {
    margin: 3px;
  }
`
export const SkeletonCardLogo = styled.div`
  max-width: 86px;
  max-height: 86px;
  width: 86px;
  height: 86px;

  margin-left: 5px;
  ${props => props.theme?.rtl && css`
    margin-right: 5px;
    margin-left: 0px;
  `}
`
export const GuestUserLink = styled.div`
  font-size: 14px;
  color: #FFFF00;
  cursor: pointer;
  margin: 10px 0;
  text-align: center;
  &:hover {
    text-decoration: underline;
  }
`
